import { __ } from "@wordpress/i18n";
import { useContext } from "react";
import { SettingsContext } from "../Settings";

const SingleVideosSettings = () => {
  const { register, single_video_settings } = useContext(SettingsContext);

  return (
    <>
      <div className="sb-tab-box sb-reset-box-style clearfix">
        <div className="tab-label">
          <h3>{__("Save new videos as", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex mb-2">
              <select
                defaultValue={single_video_settings.post_status}
                {...register("single_video_info_post_status")}
                className="sby-select single-videos-settings-select"
              >
                <option value="draft">
                  {__("Draft", "feeds-for-youtube")}
                </option>
                <option value="publish">
                  {__("Publish", "feeds-for-youtube")}
                </option>
              </select>
            </div>
            <span className="help-text">
              {__(
                "When you import new videos, they will be saved accordingly",
                "feeds-for-youtube"
              )}
            </span>
          </div>
        </div>
      </div>
      <div className="sb-tab-box clearfix">
        <div className="tab-label">
          <h3>{__("Information to Display", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field sby-single-videos-labels">
          <div className="sb-form-field">
            <div className="flex flex-col mb-10">
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_title")}
                  defaultChecked={single_video_settings.include.includes(
                    "title"
                  )}
                />
                <span className="pl-1">{__("Title", "feeds-for-youtube")}</span>
              </label>
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_user")}
                  defaultChecked={single_video_settings.include.includes(
                    "user"
                  )}
                />
                <span className="pl-1">
                  {__("User Name", "feeds-for-youtube")}
                </span>
              </label>
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_views")}
                  defaultChecked={single_video_settings.include.includes(
                    "views"
                  )}
                />
                <span className="pl-1">{__("Views", "feeds-for-youtube")}</span>
              </label>
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_date")}
                  defaultChecked={single_video_settings.include.includes(
                    "date"
                  )}
                />
                <span className="pl-1">{__("Date", "feeds-for-youtube")}</span>
              </label>
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_countdown")}
                  defaultChecked={single_video_settings.include.includes(
                    "countdown"
                  )}
                />
                <span className="pl-1">
                  {__(
                    "Live Stream Countdown (when applicable)",
                    "feeds-for-youtube"
                  )}
                </span>
              </label>
              <label>
                <input
                  type="checkbox"
                  {...register("single_video_info_stats")}
                  defaultChecked={single_video_settings.include.includes(
                    "stats"
                  )}
                />
                <span className="pl-1">
                  {__("Stats (Like and Comment Count)", "feeds-for-youtube")}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleVideosSettings;
